import React from "react";

import { SingleChevronDownIcon } from "../components/icons/CustomIcons";

import { HexButton } from "./HexButton";
import { HexSelect, HexSelectItem } from "./HexSelect";

export interface HexFilterDropdownProps {
  icon?: React.ReactElement<any>;
  items: HexSelectItem[];
  buttonTextOverride?: string;
  selectedValue: string;
  filterable?: boolean;
  onChange: (value: string) => void;
  onFilterQueryChange?: (query: string) => void;
}

/** A single-select filter button. The first item is the unfiltered default;
 * the button highlights once any other item is selected. */
export const HexFilterDropdown: React.FC<HexFilterDropdownProps> = ({
  buttonTextOverride,
  filterable = false,
  icon,
  items,
  onChange,
  onFilterQueryChange,
  selectedValue,
}) => {
  const isNotDefaultValue = selectedValue !== items[0]?.value;
  const buttonText =
    buttonTextOverride ??
    items.find((item) => item.value === selectedValue)?.title;
  return (
    <HexSelect
      autoSelectFirstItem={false}
      filterable={filterable}
      items={items}
      minimal={true}
      small={true}
      value={selectedValue}
      onChange={onChange}
      onFilterQueryChange={onFilterQueryChange}
    >
      <HexButton
        icon={icon}
        intent={isNotDefaultValue ? "primary" : undefined}
        minimal={!isNotDefaultValue}
        rightIcon={<SingleChevronDownIcon />}
        small={true}
        subtle={isNotDefaultValue}
        text={buttonText}
      />
    </HexSelect>
  );
};
